/**
 * Bridge deck, ranking, legality, visibility and vulnerability.
 */
import { SUITS, cardId, rankOf, suitOf } from '../../core/cards.js';
import { bridgeTrump } from './types.js';
export function bridgeDeck(_config) {
    const cards = [];
    for (const suit of SUITS)
        for (let r = 2; r <= 14; r++)
            cards.push(cardId(r, suit));
    return Object.freeze(cards);
}
/** Thirteen each. Dealt one at a time in the rules; the grouping is cosmetic
 *  and one step is the canonical, verifiable order. */
export function bridgeDealPlan(_config) {
    return { steps: [{ each: 13 }], firstSeatOffset: 1 };
}
export function bridgeRanking(strain) {
    const trump = strain === null ? null : bridgeTrump(strain);
    return {
        trumpSuit: trump,
        effectiveSuit: (card) => suitOf(card),
        isTrump: (card) => trump !== null && suitOf(card) === trump,
        strength: (card) => rankOf(card) ?? 0,
    };
}
export function dummyOf(declarer, seatCount) {
    return (declarer + 2) % seatCount;
}
/**
 * Vulnerability per team for board `handIndex` (0-based).
 *
 * The match's first dealer sits North of board 1, and the core moves the deal
 * one seat per hand exactly as the board numbers do, so the board's dealer and
 * the hand's dealer always agree.
 *  - chicago: none, dealer's side, dealer's side, both — in fours;
 *  - duplicate: the 16-board table of rules §1.2, with N-S the first dealer's side.
 */
const DUPLICATE = [
    'none', 'ns', 'ew', 'both', 'ns', 'ew', 'both', 'none',
    'ew', 'both', 'none', 'ns', 'both', 'none', 'ns', 'ew',
];
export function vulnerability(handIndex, dealer, seatCount, config) {
    const dealerSide = dealer % 2;
    if (config.vulnerability === 'chicago') {
        const k = handIndex % 4;
        if (k === 0)
            return [false, false];
        if (k === 3)
            return [true, true];
        return [dealerSide === 0, dealerSide === 1];
    }
    const north = ((dealer - handIndex) % seatCount + seatCount) % seatCount;
    const ns = north % 2;
    const v = DUPLICATE[handIndex % 16];
    const nsVul = v === 'ns' || v === 'both';
    const ewVul = v === 'ew' || v === 'both';
    return ns === 0 ? [nsVul, ewVul] : [ewVul, nsVul];
}
function handOver(hand, matchFinished) {
    return matchFinished || hand.phase === 'handComplete' || hand.phase === 'abandoned';
}
/** Your own hand; dummy's to everyone from the opening lead; everything at the
 *  end. */
export const bridgeVisibility = {
    holdings(hand, viewerSeat, matchFinished) {
        const over = handOver(hand, matchFinished);
        const contract = hand.contract;
        const exposed = hand.extra?.dummyExposed === true;
        const dummy = contract && typeof contract.declarer === 'number' ? dummyOf(contract.declarer, hand.secret.holdings.length) : null;
        return hand.secret.holdings.map((_, seat) => over || seat === viewerSeat || (exposed && seat === dummy) ? 'cards' : 'count');
    },
    kitty: () => 'hidden',
    discards: () => 'hidden',
};
//# sourceMappingURL=rules.js.map